import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const CheckOut = lazy(()=>import('../../components/CheckOut/CheckOut'))

const CheckOutPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <CheckOut/>
            </Suspense>
        </Fragment>
    );
};

export default CheckOutPage;